var map = {
	"./couples.json": "07I5",
	"./families.json": "YErK",
	"./main.json": "wTbr",
	"./portraits.json": "IRfe",
	"./weddings.json": "b0xR"
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	return new Promise(function(resolve, reject) {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			reject(new Error("Cannot find module '" + req + "'."));
		else
			resolve(id);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "RpDi";


//////////////////
// WEBPACK FOOTER
// ./src/assets eager ^\.\/.*\.json$
// module id = RpDi
// module chunks = 1